import { useTheme } from "../styles/theme";
import { useApp } from "../context/AppContext";

export default function Toast() {
  const S = useTheme();
  const { toast } = useApp();
  if (!toast) return null;
  return (
    <div
      style={{
        ...S.toast,
        background: toast.type === "error" ? S.colors.danger : S.colors.primary,
      }}
    >
      {toast.msg}
    </div>
  );
}
